import { app } from './firebase'
import { CreditCard } from '@/models/CreditCard'

const auth = async () => {
  const authFunc = app.functions().httpsCallable('paymentAuthFunction')
  return authFunc({
    baseUrl: process.env.VUE_APP_PAYPAL_BASE_URL,
    userName: process.env.VUE_APP_PAYPAL_VAULT_USER_NAME,
    password: process.env.VUE_APP_PAYPAL_VAULT_PASSWORD
  })
}

const storeCreditCard = async (userId, card) => {
  const authRes = await auth()
  const token = authRes.data.access_token
  const storeFunc = app.functions().httpsCallable('storeCardFunction')
  const response = await storeFunc({
    baseUrl: process.env.VUE_APP_PAYPAL_BASE_URL,
    card: {
      number: removeBlanks(card.number),
      expire_month: card.month,
      expire_year: "20" + card.year
    },
    token: token,
    userId: userId
  })
  if (response.data.id) {
    return response.data.id
  } else {
    throw new Error('Failed to save credit card info.')
  }
}

const removeBlanks = (str) => {
  if (str.includes(" ")) {
    return removeBlanks(str.replace(" ", ""))
  } else {
    return str
  }
}

const getCreditCard = async (cardId) => {
  const authRes = await auth()
  const token = authRes.data.access_token
  const getFunc = app.functions().httpsCallable('getCardFunction')
  try {
    const response = await getFunc({
      baseUrl: process.env.VUE_APP_PAYPAL_BASE_URL,
      cardId: cardId,
      token: token
    })
    return new CreditCard(
      response.data.id,
      response.data.type,
      response.data.number,
      response.data.expire_month,
      response.data.expire_year,
      new Date(response.data.create_time),
      new Date(response.data.update_time)
    )
  } catch (e) {
    throw new Error('The target card is not found.')
  }
}

export { storeCreditCard, getCreditCard }